export default __webpack_public_path__ + "static/media/8.73a3e96a.png";